import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Australian TFN generator following Single Responsibility Principle
 */
export class AusGenerator extends BaseGenerator {
  generate() {
    // Generate 8 random digits
    let tfn;
    let attempts = 0;
    
    do {
      tfn = this.randomDigits(8);
      attempts++;
    } while (!this.isValidTfn(tfn) && attempts < 100);

    return tfn;
  }

  isValidTfn(tfn) {
    const weights = [1, 4, 3, 7, 5, 8, 6, 9, 10];
    let sum = 0;

    for (let i = 0; i < 8; i++) {
      sum += parseInt(tfn[i]) * weights[i];
    }

    const remainder = sum % 11;
    return remainder === 0 || remainder === 1;
  }
}